import { SearchItemViewModel } from '@/types/api';
import { getSearchResultItemURL } from '@/features/navigation/utils/url-helpers';
import { IconSearchNormal } from '@/components/svg-symbols/icons';
import MobileSearchLink from './mobile-search-link';
interface Props {
  items: SearchItemViewModel[] | null;
  type: string;
  dataTest: string;
  queryId?: string | null;
}
function SearchResult({
  items,
  type,
  dataTest,
  queryId
}: Props) {
  return items?.length ? <ul data-test={`search-result--${dataTest}`} className='mr-2 text-text-black last-of-type:mb-8' data-sentry-component="SearchResult" data-sentry-source-file="search-result.tsx">
            {items.map(item => <li key={item.id}>
                    <MobileSearchLink href={getSearchResultItemURL(item)} item={item} queryId={queryId || ''} className='group mb-4 flex items-center rounded-xl py-1 text-sm font-medium transition-all duration-150 hover:text-brand-secondary lg:mb-3'>
                        <IconSearchNormal className='ml-2 h-5 w-5 transition-all duration-150 group-hover:text-brand-secondary' />
                        <span className='ml-1'>{type}</span>
                        <span>{item.nameFa}</span>
                    </MobileSearchLink>
                </li>)}
        </ul> : '';
}
export default SearchResult;